var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"only-list-day has--scroll"},[(!_vm.isLoading && (!_vm.appointmentList || !_vm.appointmentList.length))?_c('div',{staticClass:"empty-list-day center"},[_vm._v(" אין תורים ")]):_vm._e(),_vm._l((_vm.appointmentList),function(event){return _c('app-list-event',{key:event.id,attrs:{"event":event}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }